<template>
  <div class="content">
      <TopNavBar class="tnb"></TopNavBar>
      <slot />
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import TopNavBar from './AppLayout/TopNavBar'

const AppLayout = Vue.extend({
  name: 'AppLayout',
  data: function () {
    return {
      // logo: this.$store.state.resource.status['home-logo'] ? this.$store.state.resource.file['home-logo'] : require('../assets/logo.png')
    }
  },
  components: {
    TopNavBar
  },
  mounted () {
    if (this.$route.path.includes('/login')) {
      if (!this.$store.state.resource.status['home-logo']) {
        this.$store.dispatch('resource/getFileType', 1003)
      }
    }
  },
  methods: {
  }
})
export default AppLayout
</script>

<style lang='scss'>
.content {
  justify-content: center;
}
.page-wrapper {
  width: 1024px;
  justify-content: center;
  margin: auto;
}
.tnb {
  z-index: 0;
}
</style>
